import { Column, Wrapper as Grid } from './style';

export { Column, Grid };



// WEBPACK FOOTER //
// ../shop_main/components/grid/index.js